import { Link, useLocation } from "react-router-dom";
import * as Styled from "./styled";
import ArrowRight from "@assets/icons/arrow-right.svg?react";

export type ButtonVariant = "secondary" | "tertiary";

type Props = {
  label: string;
  variant?: ButtonVariant;
  inverse?: boolean;
  internalLink?: string;
  externalLink?: string;
  centered?: boolean;
  noArrow?: boolean;
  noWrap?: boolean;
  "data-testid"?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({
  label,
  internalLink,
  externalLink,
  noArrow,
  variant,
  inverse,
  centered,
  noWrap,
  "data-testid": testId,
  ...buttonProps
}: Props) => {
  const location = useLocation();
  const styleProps = { variant, inverse, centered, noWrap };
  const contents = (
    <>
      {label} {!noArrow && <ArrowRight />}
    </>
  );

  if (internalLink) {
    return (
      <Styled.Button
        as={Link}
        to={internalLink}
        state={{ prevLocation: location.pathname }}
        data-testid={testId}
        {...styleProps}
      >
        {contents}
      </Styled.Button>
    );
  }
  if (externalLink) {
    return (
      <Styled.Button
        as="a"
        href={externalLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId}
        {...styleProps}
      >
        {contents}
      </Styled.Button>
    );
  }
  return (
    <Styled.Button
      data-testid={testId}
      {...styleProps}
      {...buttonProps}
    >
      {contents}
    </Styled.Button>
  );
};

export default Button;
